import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { BehaviorSubject } from 'rxjs';

export enum PriceRegulationScopeType {
  Global = 'Global',
  Organization = 'Organization',
}

export enum PriceRegulationType {
  SupplementOverride = 'SupplementOverride',
  Discount = 'Discount',
}

export interface PriceRegulation {
  identifier: string;
  name: string;
  scopeType: PriceRegulationScopeType;
  organizationId: number | null;
  organizationName: string | null;
  type: PriceRegulationType;
  okSupplementOverrideInKrWithoutVat: number | null;
  organizationSupplementOverrideInKrWithoutVat: number | null;
  discountAmountInKrWithoutVat: number | null;
  locationCount: number | null;
  highlight?: BehaviorSubject<boolean>;
}

export interface PriceRegulationApiItem {
  identifier: string;
  name: string;
  scope_type: PriceRegulationScopeType;
  organization_id: number | null;
  organization_name: string | null;
  type: PriceRegulationType;
  ok_supplement_override_in_kr_without_vat?: number | null;
  organization_supplement_override_in_kr_without_vat?: number | null;
  discount_amount_in_kr_without_vat: number | null;
  location_count?: number | null;
}

export interface LocationPriceRegulationsApiResponse {
  price_regulations: {
    price_regulation: { identifier: string; name: string };
    access_group: { identifier: string; name: string };
    price_regulation_version: {
      identifier: string;
      price_regulation_type: PriceRegulationType;
      discount_amount_in_kr_without_vat: number | null;
      ok_supplement_override_in_kr_without_vat: number | null;
      organization_supplement_override_in_kr_without_vat: number | null;
    };
  }[];
}

export interface LocationPriceRegulation {
  identifier: string;
  name: string;
  type: PriceRegulationType;
  discountAmountInKrWithoutVat: number | null;
  okSupplementOverrideInKrWithoutVat: number | null;
  organizationSupplementOverrideInKrWithoutVat: number | null;
  accessGroups: { identifier: string; name: string }[];
}

export class PriceRegulationSearchEvent {
  constructor(paging: PageEvent) {
    this.paging = paging;
    this.sorting = null;
  }

  query: string | null = null;
  organizationId: number | null = null;
  type: PriceRegulationType | null = null;
  onlyGlobal = false;
  paging: PageEvent;
  sorting: Sort | null;
}
